import React, { useEffect, useState } from 'react'

const easing = {
  easeOutCubic: function (pos) {
    return Math.pow(pos - 1, 3) + 1
  },
  easeOutQuart: function (pos) {
    return -(Math.pow(pos - 1, 4) - 1)
  },
}

class ColumnWheel {
  constructor(options) {
    let defaults = {
      el: '',
      type: 'infinite',
      count: 20,
      sensitivity: 0.8,
      source: [],
      value: null,
      onChange: null,
      sound: null,
      itemsLength: 0,
    }

    this.options = Object.assign({}, defaults, options)
    // this.options.count = this.options.count - (this.options.count % 4)
    Object.assign(this, this.options)

    this.halfCount = this.options.count / 2
    this.quarterCount = this.options.count / 4
    this.a = this.options.sensitivity * 10
    this.minV = Math.sqrt(1 / this.a)
    this.selected = this.source[0]

    this.exceedA = 10
    this.moveT = 0
    this.moving = false

    this.elems = {
      el: document.querySelector(this.options.el),
      circleList: null,
      circleItems: null,

      highlight: null,
      highlightList: null,
      highListItems: null,
    }
    this.events = {
      touchstart: null,
      touchmove: null,
      touchend: null,
    }
    if (this.elems.el)
      this.itemHeight = (this.elems.el.offsetHeight * 5.5) / this.options.count
    this.itemAngle = 360 / this.options.count
    this.radius = this.itemHeight / Math.tan((this.itemAngle * Math.PI) / 180)

    this.scroll = 0
    this.soundScroll = 0
    this._init()
  }

  _init() {
    if (!this.elems.el) {
      return
    }
    this._create(this.options.source)

    let touchData = {
      startY: 0,
      yArr: [],
    }

    for (let eventName in this.events) {
      this.events[eventName] = ((eventName) => {
        return (e) => {
          if (this.elems.el.contains(e.target) || e.target === this.elems.el) {
            e.preventDefault()
            if (this.source.length) {
              this['_' + eventName](e, touchData)
            }
          }
        }
      })(eventName)
    }

    this.elems.el.addEventListener('touchstart', this.events.touchstart)
    document.addEventListener('mousedown', this.events.touchstart)
    this.elems.el.addEventListener('touchend', this.events.touchend)
    document.addEventListener('mouseup', this.events.touchend)
    if (this.source.length) {
      this.value = this.value !== null ? this.value : this.source[0].value
      this.select(this.value)
    }
  }

  _touchstart(e, touchData) {
    if (this.sound) this.sound()

    this.elems.el.addEventListener('touchmove', this.events.touchmove)
    document.addEventListener('mousemove', this.events.touchmove)
    let eventY = e.clientY || e.touches[0].clientY
    touchData.startY = eventY
    touchData.yArr = [[eventY, new Date().getTime()]]
    touchData.touchScroll = this.scroll
    this._stop()
  }

  _touchmove(e, touchData) {
    let eventY = e.clientY || e.touches[0].clientY
    touchData.yArr.push([eventY, new Date().getTime()])
    if (touchData.length > 5) {
      touchData.unshift()
    }

    let scrollAdd = (touchData.startY - eventY) / this.itemHeight
    let moveToScroll = scrollAdd + this.scroll

    if (this.type === 'normal') {
      if (moveToScroll < 0) {
        moveToScroll *= 0.3
      } else if (moveToScroll > this.source.length) {
        moveToScroll =
          this.source.length + (moveToScroll - this.source.length) * 0.3
      }
    } else {
      moveToScroll = this._normalizeScroll(moveToScroll)
    }

    if (
      Math.round(moveToScroll) < this.itemsLength &&
      Math.round(moveToScroll) >= 0 &&
      this.source[Math.round(moveToScroll)].value !==
        this.source[this.soundScroll].value
    ) {
      if (this.sound) this.sound()
      this.soundScroll = Math.round(moveToScroll)
    }

    touchData.touchScroll = this._moveTo(moveToScroll)
  }

  _touchend(e, touchData) {
    this.elems.el.removeEventListener('touchmove', this.events.touchmove)
    document.removeEventListener('mousemove', this.events.touchmove)

    let v

    if (touchData.yArr.length === 1) {
      v = 0
    } else {
      let startTime = touchData.yArr[touchData.yArr.length - 2][1]
      let endTime = touchData.yArr[touchData.yArr.length - 1][1]
      let startY = touchData.yArr[touchData.yArr.length - 2][0]
      let endY = touchData.yArr[touchData.yArr.length - 1][0]

      v = (((startY - endY) / this.itemHeight) * 1000) / (endTime - startTime)
      let sign = v > 0 ? 1 : -1

      v = Math.abs(v) > 30 ? 30 * sign : v
    }

    this.scroll = touchData.touchScroll
    this._animateMoveByInitV(v)
  }

  _create(source) {
    if (!source.length || !this.elems.el) {
      return
    }

    let template = `
        <div class="select-wrap">
          <ul class="select-options" style="transform: translate3d(0, 0, ${-this
            .radius}px) rotateX(0deg);">
            {{circleListHTML}}
            <!-- <li class="select-option">a0</li> -->
          </ul>
          <div class="highlight">
            <ul class="highlight-list m-0 p-0">
              <!-- <li class="highlight-item"></li> -->
              {{highListHTML}}
            </ul>
          </div>
        </div>
      `

    if (this.options.type === 'infinite') {
      let concatSource = [].concat(source)
      while (concatSource.length < this.halfCount) {
        concatSource = concatSource.concat(source)
      }
      source = concatSource
    }
    this.source = source
    let sourceLength = source.length

    let circleListHTML = ''
    for (let i = 0; i < source.length; i++) {
      circleListHTML += `<li class="select-option"
                      style="
                        top: ${this.itemHeight * -0.5}px;
                        height: ${this.itemHeight}px;
                        line-height: ${this.itemHeight}px;
                        transform: rotateX(${
                          -this.itemAngle * i
                        }deg) translate3d(0, 0, ${this.radius}px);
                        font-weight: bold;
                      "
                      data-index="${i}"
                      >${source[i].text}</li>`
    }

    let highListHTML = ''
    for (let i = 0; i < source.length; i++) {
      highListHTML += `<li class="highlight-item" style="height: ${this.itemHeight}px;font-weight: bold;">
                          ${source[i].text}
                        </li>`
    }

    if (this.options.type === 'infinite') {
      for (let i = 0; i < this.quarterCount; i++) {
        circleListHTML =
          `<li class="select-option"
                        style="
                          top: ${this.itemHeight * -0.5}px;
                          height: ${this.itemHeight}px;
                          line-height: ${this.itemHeight}px;
                          transform: rotateX(${
                            this.itemAngle * (i + 1)
                          }deg) translate3d(0, 0, ${this.radius}px);
                          font-weight: bold;
                        "
                        data-index="${-i - 1}"
                        >${source[sourceLength - i - 1].text}</li>` +
          circleListHTML
        circleListHTML += `<li class="select-option"
                        style="
                          top: ${this.itemHeight * -0.5}px;
                          height: ${this.itemHeight}px;
                          line-height: ${this.itemHeight}px;
                          transform: rotateX(${
                            -this.itemAngle * (i + sourceLength)
                          }deg) translate3d(0, 0, ${this.radius}px);
                          font-weight: bold;
                        "
                        data-index="${i + sourceLength}"
                        >${source[i].text}</li>`
      }

      highListHTML =
        `<li class="highlight-item" style="height: ${
          this.itemHeight
        }px;font-weight: bold;">
                            ${source[sourceLength - 1].text}
                        </li>` + highListHTML
      highListHTML += `<li class="highlight-item" style="height: ${this.itemHeight}px;font-weight: bold;">${source[0].text}</li>`
    }

    this.elems.el.innerHTML = template
      .replace('{{circleListHTML}}', circleListHTML)
      .replace('{{highListHTML}}', highListHTML)
    this.elems.circleList = this.elems.el.querySelector('.select-options')
    this.elems.circleItems = this.elems.el.querySelectorAll('.select-option')

    this.elems.highlight = this.elems.el.querySelector('.highlight')
    this.elems.highlightList = this.elems.el.querySelector('.highlight-list')
    this.elems.highlightitems =
      this.elems.el.querySelectorAll('.highlight-item')

    if (this.type === 'infinite') {
      this.elems.highlightList.style.top = -this.itemHeight + 'px'
    }

    this.elems.highlight.style.height = this.itemHeight + 10 + 'px'
    this.elems.highlight.style.lineHeight = this.itemHeight + 10 + 'px'
    this.elems.highlight.style.fontSize = '35px'
  }

  /**
   *  scroll  source.length = 5 scroll = 6.1
   *  normalizedScroll = 1.1
   * @param {init} scroll
   * @return  normalizedScroll
   */
  _normalizeScroll(scroll) {
    let normalizedScroll = scroll

    while (normalizedScroll < 0) {
      normalizedScroll += this.source.length
    }
    normalizedScroll = normalizedScroll % this.source.length
    return normalizedScroll
  }

  /**
   *
   * @param {init} scroll
   * @return
   */
  _moveTo(scroll) {
    if (this.type === 'infinite') {
      scroll = this._normalizeScroll(scroll)
    }
    let rotate = this.itemAngle * scroll
    if (rotate == 90) {
      rotate = 89.5
    } else if (rotate == 270) {
      rotate = 269.5
    }
    this.elems.circleList.style.transform = `translate3d(0, 0, ${-this
      .radius}px) rotateX(${rotate}deg)`
    this.elems.highlightList.style.transform = `translate3d(0, ${
      -scroll * this.itemHeight
    }px, 0)`
    ;[...this.elems.circleItems].forEach((itemElem) => {
      if (Math.abs(itemElem.dataset.index - scroll) > this.quarterCount) {
        itemElem.style.visibility = 'hidden'
      } else if (
        Math.abs(itemElem.dataset.index - scroll) <= this.quarterCount
      ) {
        itemElem.style.visibility = 'visible'
      }
    })

    return scroll
  }

  async _animateMoveByInitV(initV) {
    let initScroll
    let finalScroll
    let finalV

    let totalScrollLen
    let a
    let t

    if (this.type === 'normal') {
      if (this.scroll < 0 || this.scroll > this.source.length - 1) {
        a = this.exceedA
        initScroll = this.scroll
        finalScroll = this.scroll < 0 ? 0 : this.source.length - 1
        totalScrollLen = initScroll - finalScroll

        t = Math.sqrt(Math.abs(totalScrollLen / a))
        initV = a * t
        initV = this.scroll > 0 ? -initV : initV
        finalV = 0
        await this._animateToScroll(initScroll, finalScroll, t)
      } else {
        initScroll = this.scroll
        a = initV > 0 ? -this.a : this.a
        t = Math.abs(initV / a)
        totalScrollLen = initV * t + (a * t * t) / 2
        finalScroll = Math.round(this.scroll + totalScrollLen)
        finalScroll =
          finalScroll < 0
            ? 0
            : finalScroll > this.source.length - 1
            ? this.source.length - 1
            : finalScroll

        totalScrollLen = finalScroll - initScroll
        t = Math.sqrt(Math.abs(totalScrollLen / a))
        await this._animateToScroll(this.scroll, finalScroll, t, 'easeOutQuart')
      }
    } else {
      initScroll = this.scroll

      a = initV > 0 ? -this.a : this.a
      t = Math.abs(initV / a)
      totalScrollLen = initV * t + (a * t * t) / 2
      finalScroll = Math.round(this.scroll + totalScrollLen)
      await this._animateToScroll(this.scroll, finalScroll, t, 'easeOutQuart')
    }

    this._selectByScroll(this.scroll)
  }

  _animateToScroll(initScroll, finalScroll, t, easingName = 'easeOutQuart') {
    if (initScroll === finalScroll || t === 0) {
      this._moveTo(initScroll)
      return
    }

    let start = new Date().getTime() / 1000
    let pass = 0
    let totalScrollLen = finalScroll - initScroll

    return new Promise((resolve, reject) => {
      this.moving = true
      let tick = () => {
        pass = new Date().getTime() / 1000 - start

        if (pass < t) {
          this.scroll = this._moveTo(
            initScroll + easing[easingName](pass / t) * totalScrollLen,
          )
          this.moveT = requestAnimationFrame(tick)
        } else {
          resolve()
          this._stop()
          this.scroll = this._moveTo(initScroll + totalScrollLen)
        }
      }
      tick()
    })
  }

  _stop() {
    this.moving = false
    cancelAnimationFrame(this.moveT)
  }

  _selectByScroll(scroll) {
    scroll = this._normalizeScroll(scroll) | 0
    if (scroll > this.source.length - 1) {
      scroll = this.source.length - 1
      this._moveTo(scroll)
    }
    this._moveTo(scroll)
    this.scroll = scroll
    this.selected = this.source[scroll]
    this.value = this.selected.value
    this.onChange && this.onChange(this.selected)
  }

  updateSource(source) {
    this._create(source)

    if (!this.moving) {
      this._selectByScroll(this.scroll)
    }
  }

  select(value) {
    for (let i = 0; i < this.source.length; i++) {
      if (this.source[i].value === value) {
        window.cancelAnimationFrame(this.moveT)
        let initScroll = this._normalizeScroll(this.scroll)
        let finalScroll = i
        let t = Math.sqrt(Math.abs((finalScroll - initScroll) / this.a))
        this._animateToScroll(initScroll, finalScroll, t)
        setTimeout(() => this._selectByScroll(i))
        return
      }
    }
    throw new Error(
      `can not select value: ${value}, ${value} match nothing in current source`,
    )
  }

  destroy() {
    if (this.elems.el) {
      this._stop()
      for (let eventName in this.events) {
        this.elems.el.removeEventListener('eventName', this.events[eventName])
      }
      document.removeEventListener('mousedown', this.events['touchstart'])
      document.removeEventListener('mousemove', this.events['touchmove'])
      document.removeEventListener('mouseup', this.events['touchend'])
      this.elems.el.innerHTML = ''
      this.elems = null
    }
  }
}
function ScrollableWheel({
  columnsLength,
  items,
  onColumnChange,
  sensitivity,
  sound,
}) {
  const [selectors, setSelectors] = useState([])

  useEffect(() => {
    const selectors = []
    for (
      let index = 0, length = columnsLength || 3;
      index < length;
      index += 1
    ) {
      let selector = new ColumnWheel({
        el: `#wheel-${index + 1}`,
        type: 'infinite',
        source: items,
        count: 20,
        sensitivity,
        sound,
        itemsLength: items.length,
        onChange: (selected) => {
          onColumnChange(selected.value, index)
        },
      })

      selectors.push(selector)
    }
    setSelectors(selectors)

    return () => {
      selectors.forEach((el) => el.destroy())
    }
  }, [])

  return (
    <div>
      <div
        className="date-selector"
        style={{ boxShadow: '0 40px 120px rgba(0,0,0,2.2)' }}
      >
        {Array.from({ length: columnsLength }, (_, index) => index + 1).map(
          (el) => (
            <div key={el} className="wheel" id={`wheel-${el}`}></div>
          ),
        )}
      </div>
    </div>
  )
}
export default ScrollableWheel
